import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Play } from "lucide-react";

export default function LiveTV() {
  const [channels, setChannels] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/channels").then((r) => setChannels(r.data));
  }, []);

  const cats = ["All", ...Array.from(new Set(channels.map((c) => c.category)))];
  const filtered = filter === "All" ? channels : channels.filter((c) => c.category === filter);
  const featured = channels.filter((c) => c.isFeatured).slice(0, 3);

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid="live-tv-page">
      <Navbar />
      <div className="pt-32 px-4 sm:px-12 max-w-[1600px] mx-auto pb-20">
        <div className="flex items-center gap-3 mb-2">
          <span className="live-badge">LIVE</span>
          <span className="text-xs font-bold text-[#999] uppercase tracking-[0.2em]">Channels broadcasting now</span>
        </div>
        <h1 className="text-5xl sm:text-6xl font-black tracking-tighter mb-2" style={{ fontFamily: "Outfit" }}>Live TV</h1>
        <p className="text-[#999] mb-8">News, sports, music, kids — broadcasting right now.</p>

        {featured.length > 0 && (
          <div className="grid sm:grid-cols-3 gap-4 mb-10">
            {featured.map((c) => (
              <Link key={c.id} to={`/live/${c.id}`} className="relative h-44 rounded-xl overflow-hidden group bg-[#111]" data-testid={`featured-channel-${c.id}`}>
                <img src={c.logoUrl} alt={c.channelName} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute inset-0 p-5 flex flex-col justify-end">
                  <span className="live-badge mb-2 self-start">LIVE</span>
                  <div className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>{c.channelName}</div>
                  <div className="text-xs text-[#bbb] mt-1">Now: {c.currentProgram}</div>
                </div>
                <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-[#E50914] flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                  <Play className="fill-white" size={20} />
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="flex gap-2 overflow-x-auto no-scrollbar mb-6 pb-2">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition ${filter === c ? "bg-[#E50914] text-white" : "bg-white/5 hover:bg-white/10 text-[#ccc]"}`}
              data-testid={`channel-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {filtered.map((c) => (
            <Link key={c.id} to={`/live/${c.id}`} className="bg-[#111] border border-white/5 rounded-xl overflow-hidden hover:border-[#E50914]/40 transition group" data-testid={`channel-card-${c.id}`}>
              <div className="aspect-video relative overflow-hidden">
                <img src={c.logoUrl} alt={c.channelName} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <span className="absolute top-2 left-2 live-badge">LIVE</span>
                <div className="absolute bottom-2 left-3 text-xs text-[#ddd]">Now: {c.currentProgram}</div>
              </div>
              <div className="p-4">
                <div className="font-bold mb-1" style={{ fontFamily: "Outfit" }}>{c.channelName}</div>
                <div className="text-xs text-[#888] flex items-center gap-2">
                  <span>{c.country}</span> • <span>{c.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
